import { DeliveryTermAdmin } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export interface DeliveryTermsState {
    deliveryTerms: DeliveryTermAdmin[] | undefined;
    loaded: boolean;
    loading: boolean;
    error: AppError | null;
}

export const initialDeliveryTermsState: DeliveryTermsState = {
    deliveryTerms: undefined,
    loaded: false,
    loading: false,
    error: null,
};
